import { SxProps, Theme } from '@mui/material';

interface StyleMap {
  container: SxProps<Theme>;
  card: SxProps<Theme>;
  content: SxProps<Theme>;
  icon: SxProps<Theme>;
  title: SxProps<Theme>;
  message: SxProps<Theme>;
  button: SxProps<Theme>;
}

const baseStyles: StyleMap = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: '#f4f4f4',
    padding: 2,
  },
  card: {
    maxWidth: 500,
    width: '100%',
    borderRadius: 4,
    boxShadow: 3,
  },
  content: {
    textAlign: 'center',
    padding: 4,
  },
  icon: {
    fontSize: 60,
    marginBottom: 2,
  },
  title: {
    fontWeight: 'bold',
    marginBottom: 2,
  },
  message: {
    marginBottom: 3,
    fontSize: '1rem',
  },
  button: {
    paddingX: 4,
    paddingY: 1,
  },
};

export default baseStyles;
